import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useMemo, useState } from 'react';
import { FieldDecorator, FieldStepper } from '@snack-uikit/fields';
import { parseKeyToDataTest } from '../../../utils';
import { formatNumber } from '../../../utils/formatNumber';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function StepperControlUi(_ref) {
  var _ref2, _relatedUiProps$visib, _ref3, _relatedUiProps$showH;
  var decoratorProps = _ref.decoratorProps,
    uiProps = _ref.uiProps,
    value = _ref.value,
    onChange = _ref.onChange,
    watchedValues = _ref.watchedValues,
    relateFn = _ref.relateFn,
    accessorKey = _ref.accessorKey;
  var _useState = useState(value !== null && value !== void 0 ? value : 0),
    _useState2 = _slicedToArray(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedIdx = _useState4[0],
    setSelectedIdx = _useState4[1];
  var dataTestAttribute = parseKeyToDataTest('stepper', accessorKey);
  useEffect(function () {
    setInnerValue(value !== null && value !== void 0 ? value : 0);
  }, [value]);
  var _useMemo = useMemo(function () {
      var _relateFn;
      return (_relateFn = relateFn === null || relateFn === void 0 ? void 0 : relateFn(watchedValues !== null && watchedValues !== void 0 ? watchedValues : {})) !== null && _relateFn !== void 0 ? _relateFn : {};
    }, [relateFn, watchedValues]),
    relatedDecoratorProps = _useMemo.decoratorProps,
    relatedUiProps = _useMemo.uiProps;
  var _uiProps$relatedUiPro = _objectSpread(_objectSpread({}, uiProps), relatedUiProps),
    min = _uiProps$relatedUiPro.min,
    max = _uiProps$relatedUiPro.max,
    _uiProps$relatedUiPro2 = _uiProps$relatedUiPro.multiplier,
    multiplier = _uiProps$relatedUiPro2 === void 0 ? 1 : _uiProps$relatedUiPro2,
    _uiProps$relatedUiPro3 = _uiProps$relatedUiPro.step,
    step = _uiProps$relatedUiPro3 === void 0 ? 1 : _uiProps$relatedUiPro3,
    allowedValues = _uiProps$relatedUiPro.allowedValues;
  useEffect(function () {
    if (allowedValues) {
      var idx = allowedValues.findIndex(function (item) {
        return item === value;
      });
      setSelectedIdx(idx >= 0 ? idx : 0);
    }
  }, [allowedValues, value]);
  useEffect(function () {
    if (min && Number((value !== null && value !== void 0 ? value : 0) / multiplier) < min) {
      onChange === null || onChange === void 0 ? void 0 : onChange(min * multiplier);
      return;
    }
    if (max && Number((value !== null && value !== void 0 ? value : 0) / multiplier) > max) {
      onChange === null || onChange === void 0 ? void 0 : onChange(max * multiplier);
      return;
    }
  }, [value, onChange, min, max, multiplier]);
  var visible = (_ref2 = (_relatedUiProps$visib = relatedUiProps === null || relatedUiProps === void 0 ? void 0 : relatedUiProps.visible) !== null && _relatedUiProps$visib !== void 0 ? _relatedUiProps$visib : uiProps === null || uiProps === void 0 ? void 0 : uiProps.visible) !== null && _ref2 !== void 0 ? _ref2 : true;
  var showHint = (_ref3 = (_relatedUiProps$showH = relatedUiProps === null || relatedUiProps === void 0 ? void 0 : relatedUiProps.showHint) !== null && _relatedUiProps$showH !== void 0 ? _relatedUiProps$showH : uiProps.showHint) !== null && _ref3 !== void 0 ? _ref3 : true;
  var handleValueChange = function handleValueChange(rawInnerValue) {
    var innerValue = Number(rawInnerValue !== null && rawInnerValue !== void 0 ? rawInnerValue : 0);
    if (allowedValues) {
      onChange === null || onChange === void 0 ? void 0 : onChange(innerValue);
      return;
    }
    if (min && innerValue / multiplier <= min) {
      onChange === null || onChange === void 0 ? void 0 : onChange(min * multiplier);
      setInnerValue(min);
      return;
    }
    if (max && innerValue / multiplier >= max) {
      onChange === null || onChange === void 0 ? void 0 : onChange(max * multiplier);
      setInnerValue(max);
      return;
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(innerValue);
  };
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/_jsxs(FieldDecorator, _objectSpread(_objectSpread(_objectSpread({}, decoratorProps), relatedDecoratorProps), {}, {
    size: "m",
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FieldStepper, _objectSpread(_objectSpread({
        size: "m",
        value: (innerValue !== null && innerValue !== void 0 ? innerValue : 0) / multiplier,
        postfix: uiProps.postfix,
        onChange: function onChange(value) {
          if (allowedValues) {
            var currentIdx = selectedIdx;
            var isIncrement = value > innerValue / multiplier;
            var newIdx = isIncrement ? Math.min(currentIdx + 1, allowedValues.length - 1) : Math.max(currentIdx - 1, 0);
            setSelectedIdx(newIdx);
            handleValueChange(allowedValues[newIdx] * multiplier);
            return;
          }
          if (Math.abs(value - innerValue / multiplier) === step) {
            handleValueChange === null || handleValueChange === void 0 ? void 0 : handleValueChange(value * multiplier);
            return;
          }
          setInnerValue === null || setInnerValue === void 0 ? void 0 : setInnerValue(value * multiplier);
        },
        onBlur: function onBlur() {
          handleValueChange(innerValue);
        },
        allowMoreThanLimits: false,
        "data-test-id": dataTestAttribute
      }, uiProps), relatedUiProps))
    }), showHint && /*#__PURE__*/_jsxs("div", {
      className: styles.hintWrapper,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.hint,
        children: formatNumber(min)
      }), /*#__PURE__*/_jsx("span", {
        className: styles.hint,
        children: formatNumber(max)
      })]
    })]
  }));
}